import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

const PlusIconShadow = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 71}
          height={props.height ?? 56}
          viewBox="0 0 71 56"
          fill="none"
          {...props}
        >
          <Path
            d="M47.5039 43.9437C49.0035 43.0902 50.2187 40.9694 50.2187 39.2366L50.2187 17.046C50.2187 15.3132 49.0035 13.2183 47.5039 12.3389L28.293 1.24363C26.7934 0.390144 24.3629 0.390143 22.8633 1.24363L3.65237 12.3389C2.15273 13.1924 0.937503 15.3132 0.937503 17.046L0.937502 39.2366C0.937502 40.9694 2.15273 43.0644 3.65237 43.9437L22.8633 55.039C24.3629 55.8925 26.7934 55.8925 28.293 55.039L47.5039 43.9437Z"
            fill="#FFB600"
            fillOpacity="0.22"
          />
          <Path
            d="M54.3759 50.987H39.8339V34.2077H23.1562V22.513H39.8339V6.24219H54.3759V22.513H70.9518V34.2077H54.3759V50.987Z"
            fill="url(#paint0_linear_1_39126)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_1_39126"
              x1="47.054"
              y1="6.24219"
              x2="47.054"
              y2="50.987"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stopColor={'#FF9900'} />
            </LinearGradient>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { PlusIconShadow };
